import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { customPushToDataLayer } from '../../../analytics/analytics';
import { useSettings } from '../../../context/Settings';
import { BackgroundGradient } from '../../BackgroundGradient/BackgroundGradient';
import { Icon } from '../../Layout/Icon/Icon';
import { cookiePolicyLink, privacyPolicyLink, termsOfUseLink } from './menu.helpers';
import { useNavigate, useParams } from 'react-router';
import { useLanguageHelper } from '../../../utils/language_helper';

export const Menu = () => {
  const { settings, saveSettings } = useSettings();
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const { lang } = useParams<{ lang: string }>();

  const onClickOut = (engTitle?: string, translatedTitle?: string) => {
    saveSettings({ showMenu: false });
    if (engTitle && translatedTitle) {
      customPushToDataLayer({
        event: 'menu_click',
        menu_title: engTitle,
        menu_title_local: translatedTitle,
      });
    }
  };

  const handleChangeCountry = () => {
    navigate('/');
    window.location.reload();
  };

  const { isEnglish } = useLanguageHelper();

  const termsOfUsePath = termsOfUseLink(i18n.language);
  const privacyPolicyPath = privacyPolicyLink(i18n.language);
  const cookiePolicyPath = cookiePolicyLink(i18n.language);

  const currentLang = lang || settings.language || 'en';

  return (
    <div className="menu-container">
      <menu className={`menu ${settings.showMenu ? 'menu--visible' : ''}`}>
        <button className="menu__close button" onClick={() => onClickOut()} aria-label={'close menu'}>
          <Icon name="close" stroke="#1E223C" fill="none" size={60} />
        </button>
        <div className="menu__items">
          <ul>
            <li onClick={() => onClickOut('home', t('menu.home'))}>
              <Link to={`/${currentLang}/home`}>{t('menu.home')}</Link>
            </li>
            <li onClick={() => onClickOut('Virtual Roleplays', t('menu.virtual_roleplays'))}>
              <Link to={`/${currentLang}/roleplay`}>{t('menu.virtual_roleplays')}</Link>
            </li>
            <li onClick={() => onClickOut('About', t('menu.about'))}>
              <Link to={`/${currentLang}/about`}>{t('menu.about')}</Link>
            </li>
            <li onClick={() => onClickOut('References', t('menu.references'))}>
              <Link to={`/${currentLang}/references`}>{t('menu.references')}</Link>
            </li>
          </ul>
          <div className="menu__items__user">
            <button className="menu__change-country button" onClick={handleChangeCountry}>
              Change country
            </button>
          </div>
        </div>
        <div className="menu__footer">
          <ul className="menu__info">
            <li onClick={() => onClickOut('Terms Of Use', t('menu.terms_of_use'))}>
              <a href={termsOfUsePath} target="_blank" rel="noopener noreferrer">
                {t('menu.terms_of_use')}
              </a>
            </li>
            <li onClick={() => onClickOut('Privacy Policy', t('menu.privacy_policy'))}>
              <a href={privacyPolicyPath} target="_blank" rel="noopener noreferrer">
                {t('menu.privacy_policy')}
              </a>
            </li>
            {(isEnglish || i18n.language === 'de' || i18n.language === 'es') ? (
              <li onClick={() => onClickOut('Cookie Policy', t('menu.cookie_policy'))}>
                <a href={cookiePolicyPath} target="_blank" rel="noopener noreferrer">
                  {t('menu.cookie_policy')}
                </a>
              </li>
            ) : (
              <li onClick={() => onClickOut('Cookie Policy', t('menu.cookie_policy'))}>
                <Link to={`/${currentLang}/cookie-policy`}>{t('menu.cookie_policy')}</Link>
              </li>
            )}
          </ul>
        </div>
      </menu>
      <BackgroundGradient />
    </div>
  );
};
